import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/loader.gif")